<template>
  <esg-base-dashboard-card title="온실가스 배출량">
    <apex-chart type="donut"
                width="450"
                class="my-3"
                :options="chartOptions"
                :series="series"/>
  </esg-base-dashboard-card>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";

export default {
  components: {
    EsgBaseDashboardCard,
  },
  data() {
    return {
      series: [1275,4813],
      chartOptions: {
        labels: ['EY 정공', 'Others'],
        colors: ['#008FFB', '#999'],
        chart: {
          type: 'donut',
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toLocaleString('ko-KR') + " tCO2e"
            },
          },
        },
        legend: {
          position: 'right',
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  // formatter: val => Number(val).toLocaleString('ko-KR') +`개 사`
                  formatter: function (val) {
                    return `${Number(val).toLocaleString('ko-KR')} tCO2e`;
                   },
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#000000',
                  formatter: chart => chart.config.series.reduce((sum, current) => sum + current, 0).toLocaleString('ko-KR') + 'tCO2e'
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 576,
            options: {
              chart: { width: 350 },
              legend: { position: 'bottom' }
            }
          }
        ]
      }
    }
  }
}
</script>
